import { Filters } from 'features/Filters/types/Filters';

export const getNumberOfActiveFilters = (filters: Filters): number => {
  return Object.values(filters).reduce((count, filterArray) => count + filterArray.length, 0);
};
